import { type FC } from 'react'
import { ApexDisclosuresV3 } from './apex-disclosures-v3'

export const ApexDisclosures: FC = () => {
  return <ApexDisclosuresV3 />
}
